import { unionBy } from 'lodash';

const mergeByProp = (arr, obj, prop) => {
  const i = arr.findIndex(el => el[prop] === obj[prop]);

  return i === -1
    ? [...arr, obj]
    : [...arr.slice(0, i), obj, ...arr.slice(i + 1)];
};

export default function studentLearningTasks(
  state = {
    page: 0,
    count: 0,
    notifications: [],
  },
  action,
) {
  switch (action.type) {
    case 'ALL_NOTIFICATIONS/INC_PAGE':
      return {
        ...state,
        page: state.page + 1,
      };

    case 'ALL_NOTIFICATIONS/MERGE_NOTIFICATIONS':
      return {
        ...state,
        notifications: unionBy(state.notifications, action.results, 'id'),
        count: action.count,
      };

    case 'ALL_NOTIFICATIONS/PRE_MERGE_NOTIFICATIONS':
      return {
        ...state,
        notifications: unionBy(action.results, state.notifications, 'id'),
        count: action.count,
      };

    case 'ALL_NOTIFICATIONS/MARK_NOTIFICATION_READ':
      return {
        ...state,
        notifications: mergeByProp(
          [...state.notifications],
          action.payload,
          'id',
        ),
      };

    default:
      return state;
  }
}
